import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pc_loby = _resolveComponent("pc-loby")
  const _component_mobile_loby = _resolveComponent("mobile-loby")

  return (_ctx.device.display !== 1)
    ? (_openBlock(), _createBlock(_component_pc_loby, { key: 0 }))
    : (_openBlock(), _createBlock(_component_mobile_loby, { key: 1 }))
}